import {
  marketTemple,
  marketCamping,
  marketFarm,
  marketFit,
  marketSpa,
  marketCottage,
  marketHut,
  marketLand,
  marketCoWorking,
  marketCafe,
  marketArt,
  marketAcademy,
  marketBank,
  marketBusiness,
  marketEmpire,
  marketIsland,
} from '@app/assets';

export const SETTLEMENT_MARKET = [
  {
    name: 'land',
    ton: 1,
    icon: marketLand,
  },
  {
    name: 'camping',
    ton: 2,
    icon: marketCamping,
  },
  {
    name: 'hut',
    ton: 4,
    icon: marketHut,
  },
  {
    name: 'cottage',
    ton: 8,
    icon: marketCottage,
  },
  {
    name: 'co_working',
    ton: 16,
    icon: marketCoWorking,
  },
  {
    name: 'cafe',
    ton: 32,
    icon: marketCafe,
  },
  {
    name: 'farm',
    ton: 48,
    icon: marketFarm,
  },
  {
    name: 'spa',
    ton: 64,
    icon: marketSpa,
  },
  {
    name: 'temple',
    ton: 96,
    icon: marketTemple,
  },
  {
    name: 'fit',
    ton: 128,
    icon: marketFit,
  },
  {
    name: 'art',
    ton: 192,
    icon: marketArt,
  },
  {
    name: 'academy',
    ton: 256,
    icon: marketAcademy,
  },
  {
    name: 'bank',
    ton: 384,
    icon: marketBank,
  },
  {
    name: 'business-center',
    ton: 512,
    icon: marketBusiness,
  },
  {
    name: 'dom_empire',
    ton: 768,
    icon: marketEmpire,
  },
  {
    name: 'island',
    ton: 1024,
    icon: marketIsland,
  },
];

export const SETTLEMENT_FILL_BAR = [3, 10, 30, 100, 300, 1000, 3000, 10000];
